interface ErrorDisplayProps {
  title?: string;
  message: string;
  onRetry?: () => void;
}

export function ErrorDisplay({
  title = 'Error',
  message,
  onRetry,
}: ErrorDisplayProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-lg border border-widget-danger/20 bg-widget-danger/5 p-6 text-center">
      <div className="text-3xl">!</div>
      <h3 className="text-sm font-semibold text-widget-danger">{title}</h3>
      <p className="text-sm text-widget-text-muted">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-2 rounded-md bg-widget-primary px-4 py-1.5 text-sm font-medium text-white hover:bg-widget-primary/90 transition-colors"
        >
          Reintentar
        </button>
      )}
    </div>
  );
}
